<div class="flag__content">
	<span *ngIf="!hasSSR" class="no-ssr" [title]="tooltipTitle.hasSSR"><i class="fas fa-flag"></i></span>
	<span *ngIf="cellValue.guaranteeState > 0" class="cvGuarantee"
		[title]="tooltipTitle.cvGuarantee">
		<i class="fas fa-award" [ngClass]="{
			'pending': cellValue.guaranteeState === 1,
			'elegible': cellValue.guaranteeState === 2,
			'not-elegible': cellValue.guaranteeState === 3
		}"></i>
	</span>
</div>
